export const STATINFO = [
    {
        id: 0,
        title: "Health",
        consumableTitle: "Health",
        resource: 100
    },
    {
        id: 1,
        title: "Stamina",
        consumableTitle: "Stamina",
        resource: 100
    }
]